import ERRORS from './errors';
import SswCore from './ssw_core';
import Console from './console';
import storage from './fallback_storage';

const console = new Console(window.Settings.SESSIONWIDGET_DEBUG);

class SessionWidgetApi {
    constructor(settings = {}) {
        this.debug = settings.SESSIONWIDGET_DEBUG || false;
        this.core = new SswCore(settings);

        this.allowedOrigins = settings.SESSIONWIDGET_ALLOWED_ORIGINS;

        window.addEventListener('message', (event) => this.handleMessage(event), false);
    }

    static sendError(event, code = ERRORS.DEFAULT, msg) {
        const error = {
            error: code,
            extra: msg
        };

        console.warn(error.extra, event, error);
        SessionWidgetApi.sendTokenResponse(event, error);
        return error;
    }

    static sendTokenResponse(requestEvent, responseData) {
        const response = Object.assign({}, responseData, {
            promiseId: requestEvent.data.promiseId
        });

        console.info('Widget: sending response:  ', response);
        requestEvent.source.postMessage(response, requestEvent.origin);
    }

    handleAction(event) {
        const action = event.data.action;
        const clientId = event.data.clientId;

        if (!action || !clientId) {
            console.info('Widget: wrong request. Required action and clientId.');
            return;
        }
        const scope = event.data.scope;
        let promise;

        switch (action) {
            case 'requestToken':
                promise = this.core.handleTokenRequest(event, clientId, scope);
                break;
            case 'revokeToken':
                promise = this.core.revokeToken(event, clientId, scope);
                break;
            case 'menuToken':
                promise = this.core.getMenuToken(event, clientId);
                break;
            case 'accountId':
                promise = this.core.getAccountId(event, clientId);
                break;
            case 'accountInfo':
                promise = this.core.getAccountInfo(event, clientId);
                break;
            case 'readyState':
                promise = Promise.resolve(true);
                break;
            default:
                SessionWidgetApi.sendError(
                    event,
                    ERRORS.ACTION_NOT_DEFINED,
                    'Widget: message refused, unknown action.'
                );
        }
        if (promise) {
            promise.then((token = {}) => {
                SessionWidgetApi.sendTokenResponse(event, token);
            }).catch((error = {}) => {
                SessionWidgetApi.sendError(
                    event,
                    error.error,
                    error.error_description
                );
            });
        }
    }

    handleMessage(event = {}) {
        if (storage.disabled) {
            SessionWidgetApi.sendError(
                event,
                ERRORS.THIRD_PARTY_DISABLED,
                'Widget: message refused, third party cookies disabled'
            );
            return;
        }
        if (this.allowedOrigins.indexOf(event.origin) === -1) {
            SessionWidgetApi.sendError(
                event,
                ERRORS.ORIGIN_NOT_ALLOWED,
                `Widget: message refused, origin: ${event.origin}`
            );
            return;
        }

        if (!event.data) {
            SessionWidgetApi.sendError(
                event,
                ERRORS.EVENT_DATA_REQUIRED,
                'Widget: message refused, data not found'
            );
            return;
        }

        console.info(`Widget: a message received ${event.data}`);
        this.handleAction(event);
    }
}

export default new SessionWidgetApi(window.Settings);



// WEBPACK FOOTER //
// ./static_source/js/ssw_api.js